<template>
    <div>
        <div class="header">
            <div class="header_t">
                <p class="header_tf">易凡云CDN</p>
                <span class="header_ttw">融合主流CDN厂商节点</span>
                <div class="header_b">
                    <span>提供稳定快速的网络访问服务</span>
                    <span>通过全方位的 CDN 质量监控，以及智能易用的节点调度等功能。</span>
                    <span>保障客户的音视频点播、大文件下载、应用及Web加速服务的稳定及连续性</span>
                </div>
            </div>
            <img src="../assets/imgs/successBag.png" class="fruit_img">
        </div>
        <!-- 调度方式 -->
        <div class="content_t">
            <el-row>
                <el-col :xs="24" :sm="24">
                    <div class="product_pc_one">
                        <div class="content_tone">
                            <span>节点资源：华为云、火山云、阿里云</span>
                        </div>
                        <div class="content_ttwo">
                            <span>人工切换：客户指定厂商的特殊需求进行人工介入</span>
                        </div>
                        <div class="content_tthree">
                            <span>自动切换：根据时间、地区系统自动进行节点分配</span>
                        </div>
                        <div class="content_tfour">
                            <span>厂商切换：从AB厂商切换到AC厂商，自动同步配置完成校验后自动切换</span>
                        </div>
                        <div class="product_pc">
                            <div class="product_pct">调度方式</div>
                            <img src="../assets/imgs/successtwo.png" alt="">
                            <span class="product_pctsp">易凡云控制台</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 伙伴介绍 -->
        <div class="bottom_b">
            <el-row>
                <el-col :xs="24" :sm="24">
                    <div class="product_pc_one">
                        <div class="product_pct">伙伴介绍</div>
                        <div class="product_pc">
                            <div class="product_pc_left">
                                <img src="../assets/imgs/successfour.png" alt="">
                            </div>
                            <div class="product_pc_right">
                                <p>需求商</p>
                                <span>企业、个人均可向易凡云咨询CDN产品的相关问题。获得无差别对待的服务支撑。</span>
                                <span>代理伙伴，若您有代理我们产品的意向欢迎您和我们取得联系，获取产品相关培训及代理方案。</span>
                            </div>
                        </div>
                           <div class="product_pcTwo" >
                            <div class="product_pc_left">
                                <img src="../assets/imgs/successsix.png" alt="">
                            </div>
                            <div class="product_pc_right">
                                <p>供应商</p>
                                <span>国内优秀CDN厂商：华为云、火山云、阿里云、京东云、金山云等。</span>
                                <span> 易凡云深入合作的战略伙伴：华为云、火山云、阿里云。最大程度保障节点质量高可用。</span>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
  name: "Fruit",
  data() {
    return {
    };
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.header {
  position: relative;
}
.header .header_t {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 117px;
  left: 348px;
animation: header_t 2s;
}

@keyframes header_t {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}
.header .header_t .header_tf {
  font-size: 32px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 24px;
}
.header .header_t .header_ttw {
  font-size: 40px;
  font-weight: 600;
  color: #0066ff;
  line-height: 40px;
  margin: 23px 0;
  letter-spacing: 5px;
}
.header .header_t .header_b {
  display: flex;
  flex-direction: column;
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 40px;
}
.header .fruit_img {
  height: 492px;
  width: 100%;
}
.content_t {
  width: 1005;
  height: 835px;
  background: linear-gradient(180deg, #feffff 0%, #eef4ff 100%);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}
.content_t .product_pc_one {
  position: relative;
}
.content_t .product_pc_one .content_tone {
  padding: 34px 33px;
  background: #ffffff;
  box-shadow: 0px 4px 18px 0px rgb(0 0 0 / 10%);
  border-radius: 49px;
  /* width: 355px; */
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  position: absolute;
  color: #848b99;
  top: 44%;
  left: 23%;
  animation: content_tone 2s;
}
@keyframes content_tone {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
.content_t .product_pc_one .content_ttwo {
  padding: 34px 33px;
  background: #ffffff;
  box-shadow: 0px 4px 18px 0px rgb(0 0 0 / 10%);
  border-radius: 49px;
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  position: absolute;
  color: #848b99;
  top: 52%;
  right: 15.5%;
  animation: content_ttwo 2s;
}
@keyframes content_ttwo {
  0% {
    opacity: 0;
   transform: translate3d(0, -200%, 0);
  }
}
.content_t .product_pc_one .content_tthree {
  padding: 34px 33px;
  background: #ffffff;
  box-shadow: 0px 4px 18px 0px rgb(0 0 0 / 10%);
  border-radius: 49px;
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  position: absolute;
  color: #848b99;
  bottom: 4%;
  /* width: 25%; */
  left: 16%;
  animation: content_tthree 2s;
}
@keyframes content_tthree {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
.content_t .product_pc_one .content_tfour {
  padding: 34px 33px;
  background: #ffffff;
  box-shadow: 0px 4px 18px 0px rgb(0 0 0 / 10%);
  border-radius: 49px;
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  position: absolute;
  color: #848b99;
  /* width: 34%; */
  bottom: -14.5%;
  right: 15%;
  animation: content_tfour 2s;
}
@keyframes content_tfour {
  0% {
    opacity: 0;
    transform: translate3d(0, -200%, 0);
  }
}
.content_t .product_pc_one .product_pc {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.content_t .product_pc_one .product_pc .product_pct {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 84px 0 141px 0;
}
.content_t .product_pc_one .product_pc .product_pctsp {
  font-size: 20px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #0066ff;
  line-height: 48px;
  position: absolute;
  bottom: 7%;
}
.bottom_b {
  height: 845px;
}
.bottom_b .product_pc_one {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bottom_b .product_pc_one .product_pct {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 80px 0 55px 0;
}
.bottom_b .product_pc_one .product_pc {
  background-image: url("../assets/imgs/successthree.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 1036px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom_b .product_pc_one .product_pc .product_pc_left {
  width: 278px;
  height: 256px;
  background: linear-gradient(315deg, #0066ff 0%, #e1edff 100%);
  border-radius: 10px 0px 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bottom_b .product_pc_one .product_pc .product_pc_right {
  display: flex;
  flex-direction: column;
  margin-left: 48px;
}
.bottom_b .product_pc_one .product_pc .product_pc_right p {
  font-size: 24px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 24px;
  margin-bottom: 19px;
}
.bottom_b .product_pc_one .product_pc .product_pc_right span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 40px;
}
.bottom_b .product_pc_one .product_pcTwo {
  background-image: url("../assets/imgs/successfive.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 1036px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 55px;
}
.bottom_b .product_pc_one .product_pcTwo .product_pc_left {
  width: 278px;
  height: 256px;
  background: linear-gradient(315deg, #0066ff 0%, #e1edff 100%);
  border-radius: 10px 0px 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bottom_b .product_pc_one .product_pcTwo .product_pc_right {
  display: flex;
  flex-direction: column;
  margin-left: 48px;
}
.bottom_b .product_pc_one .product_pcTwo .product_pc_right p {
  font-size: 24px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 24px;
  margin-bottom: 19px;
}
.bottom_b .product_pc_one .product_pcTwo .product_pc_right span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 40px;
}
</style>